import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useOutsideClick } from '../../hooks/useOutsideClick';
import { api } from '../../store/api/api';
import { logout } from '../../store/slices/authSlice';
import { showToast } from '../../store/slices/uiContextSlice';
import { AuthError } from './auth/AuthError';
import { AuthUserAva, AuthUserInfo } from './auth/AuthUserCard';

export function Auth() {
  const dispatch = useDispatch();
  const [clickOutside, setClickOutside] = useState(true);

  const token = localStorage.getItem('forumAppToken');

  const { status } = useSelector((state) => state.auth);

  const authenticated = status === 'authenticated';
  const loading = status === 'pending';
  const rejected = status === 'rejected';
  const unauthenticated =
    status === 'unauthenticated' ||
    status === 'uninitialized' ||
    status === 'rejected';

  const handleClickOutside = () => {
    setClickOutside(true);
  };

  const ref = useOutsideClick(handleClickOutside);

  const handleLoginButton = () => {
    document.getElementById('loginDialog').showModal();
    setClickOutside(true);
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  const handleAccountButton = () => {
    setClickOutside(false);
  };

  useEffect(() => {
    if (token) {
      dispatch(api.endpoints.getCurrentUser.initiate());
    }
    if (rejected) {
      dispatch(
        showToast({
          id:
            Math.random().toString(36).substring(2, 4) +
            Date.now().toString(36),
          type: 'danger',
          description: 'Session expired. Please login again',
        })
      );
    }
  }, [token, dispatch, authenticated, rejected]);

  return (
    <>
      {authenticated ? (
        <div className="relative z-40 grid place-items-center">
          <button
            onClick={handleAccountButton}
            id="accountMenuButton"
            className="lg:py-2"
          >
            <div className="grid grid-flow-col gap-2 overflow-hidden">
              <AuthUserAva />
              <div className="hidden text-start lg:block">
                <AuthUserInfo />
              </div>
            </div>
          </button>

          {!clickOutside && (
            <ul
              ref={ref}
              className="dark:highlight-gray-50/5 absolute z-50 mr-4 mt-4 w-48 overflow-hidden rounded-lg bg-gray-50 py-1 text-sm text-gray-700 shadow-lg ring-1 ring-gray-900/10 dark:bg-gray-800 dark:text-gray-300 dark:ring-0 max-[767px]:right-0 max-[767px]:top-full md:left-3 md:bottom-14"
            >
              <li className="py-3 px-2 lg:hidden">
                <AuthUserInfo />
              </li>
              <li className="flex cursor-pointer items-center py-3 px-2 hover:font-semibold">
                <button
                  onClick={handleLogout}
                  className="w-full px-3 py-2 text-left hover:bg-indigo-500/5 dark:hover:bg-indigo-500/5"
                >
                  Logout
                </button>
              </li>
            </ul>
          )}
        </div>
      ) : (
        ''
      )}

      {unauthenticated ? (
        <div className="relative z-30 px-2 lg:w-full lg:px-0">
          <button
            disabled={loading}
            onClick={handleLoginButton}
            className="grid place-items-center rounded-2xl bg-indigo-400/90 px-4 py-2 text-indigo-900 shadow backdrop-blur hover:bg-indigo-400 hover:shadow-md supports-[backdrop-filter]:bg-indigo-400/60 hover:supports-[backdrop-filter]:bg-indigo-400/80 dark:bg-indigo-800/90 dark:text-indigo-100 dark:hover:bg-indigo-800 dark:supports-[backdrop-filter]:bg-indigo-800/30 dark:hover:supports-[backdrop-filter]:bg-indigo-800/60 lg:w-full lg:rounded-full lg:py-3 lg:text-xl lg:font-medium"
          >
            {loading ? 'Logging in..' : 'Login'}
          </button>
        </div>
      ) : (
        ''
      )}

      <AuthError />
    </>
  );
}
